import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryInput } from 'src/Components/PrimaryInput'
import { PrimaryTextArea } from 'src/Components/PrimaryTextArea'
import { variables } from 'src/Styled/variables'
import { PrimaryRadio } from 'src/Components/PrimaryRadio'

import { SvgIcon } from './helpers'

const StyledRadio = styled(PrimaryRadio)`
  color: ${({ theme }) => theme.color.darkGrey};
  gap: 16px;
  height: 42px;

  span {
    padding-inline-start: 0 !important;
    padding-inline-end: 0 !important;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
`

const IconWrapper = styled.span`
  display: flex;
  width: 16px;
  height: 16px;
`

const ItemName = styled.span`
  font-family: 'Segoe UI';
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize14};
  font-style: normal;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  .ant-input-data-count {
    margin-bottom: 8px;
  }
`

export interface SurveyItemProps {
  Icon: SvgIcon
  inputType?: 'input' | 'textarea'
  title: string
  placeholder?: string
  isChecked?: boolean
  maxLength?: number
}
const TEXTAREA_MAX_LENGTH = 100

export const SurveyItem: FC<SurveyItemProps> = ({
  Icon,
  title,
  inputType,
  placeholder,
  isChecked,
  maxLength,
  ...props
}) => (
  <Container>
    <StyledRadio value={title}>
      <IconWrapper>
        <Icon width={16} height={16} />
      </IconWrapper>
      <ItemName>{title}</ItemName>
    </StyledRadio>

    {isChecked && inputType === 'input' && (
      <PrimaryInput
        {...props}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    )}

    {isChecked && inputType === 'textarea' && (
      <PrimaryTextArea
        {...props}
        placeholder={placeholder}
        style={{ height: 180, resize: 'none' }}
        count={{
          show: (count) =>
            count.value ? `${count.count}/${TEXTAREA_MAX_LENGTH}` : '',
        }}
        maxLength={TEXTAREA_MAX_LENGTH}
      />
    )}
  </Container>
)
